import { useState } from "react";
import { Loader2, Plus, QrCode } from "lucide-react";
import { PageHeader } from "@/components/app-layout";
import { Button } from "@/components/ui/button";
import { Card, CardBody } from "@/components/ui/card";
import { Alert } from "@/components/ui/alert";
import { ErrorAlert } from "@/components/error-alert";
import { AccountCard } from "@/components/account-card";
import { QrLoginDialog } from "@/components/qr-login-dialog";
import { useAccounts } from "@/lib/accounts";

export function AccountsPage() {
    const [dialogOpen, setDialogOpen] = useState(false);
    const { data: accounts, isPending, error } = useAccounts();

    const needsRelogin = accounts?.filter((account) => account.status === "NEEDS_RELOGIN") ?? [];

    return (
        <>
            <PageHeader
                title="Tài khoản Zalo"
                description="Quét QR để thêm tài khoản và đặt giới hạn gửi cho từng tài khoản"
                action={
                    <Button onClick={() => setDialogOpen(true)}>
                        <Plus className="size-4" />
                        Thêm tài khoản
                    </Button>
                }
            />

            <div className="space-y-4 p-8">
                {needsRelogin.length > 0 && (
                    <Alert tone="danger">
                        {needsRelogin.length} tài khoản mất phiên đăng nhập. Quét QR lại để tiếp tục gửi — chiến
                        dịch của các tài khoản này đang bị dừng.
                    </Alert>
                )}

                {isPending && (
                    <div className="flex justify-center py-16">
                        <Loader2 className="size-6 animate-spin text-ink-muted" aria-label="Đang tải" />
                    </div>
                )}

                <ErrorAlert error={error} context="Không tải được danh sách tài khoản" />

                {accounts?.length === 0 && (
                    <Card>
                        <CardBody className="flex flex-col items-center gap-3 py-14 text-center">
                            <QrCode className="size-9 text-ink-muted" />
                            <div>
                                <p className="font-medium text-ink">Chưa có tài khoản nào</p>
                                <p className="mt-0.5 text-sm text-ink-muted">
                                    Thêm tài khoản Zalo cá nhân bằng cách quét mã QR trên điện thoại.
                                </p>
                            </div>
                            <Button onClick={() => setDialogOpen(true)}>
                                <Plus className="size-4" />
                                Thêm tài khoản
                            </Button>
                        </CardBody>
                    </Card>
                )}

                {accounts?.map((account) => <AccountCard key={account.id} account={account} />)}
            </div>

            <QrLoginDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
        </>
    );
}
